import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, callGameServerApi, formatMoney, getInlineLoader, isAlphanumeric, resolveOrientation } from '../Helpers';
import chess_pieces from '../assets/chess_pieces.png';
import logo_wide from '../assets/logo_wide.png';
import { IoEnterOutline } from 'react-icons/io5';
import { MdArrowBack } from 'react-icons/md'
import TopBar from '../components/TopBar';
import { GAME_TYPES, PLAY_MODES } from '../Constants';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "landscape";
  const currentDateTime = new Date();
  currentDateTime.setHours(currentDateTime.getHours() + 3);

  const [ error, setError ] = useState(false);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  
  const [ selectedGame, setSelectedGame ] = useState(GAME_TYPES.BRAZILIAN_CHECKERS);
  const [ noParticipants, setNoParticipants ] = useState(2);
  const [ entranceFee, setEntranceFee ] = useState(10);
  const [ startDate, setStartDate ] = useState(currentDateTime.toISOString().slice(0, 16));
  const [ winnerAward, setWinnerAward ] = useState(calculateWinnerAward());

  function calculateWinnerAward() {
    const totalCoins = entranceFee * noParticipants;
    const winnerCoins = (appContext.mainParams.leagueWinnerPercent/100) * totalCoins;
    const winnerCash = winnerCoins * appContext.mainParams.coinToTsh;
    return winnerCash;
  }

  const init = () => {
    appContext.changeOrientation(requiredOrientation);
    setReady(true);
  }


  const createLeague = async () => {
    //create match for the selected game
    if(!loading) {
      if(selectedGame && selectedGame.trim().length > 0) {
        if(Number(noParticipants) >= 2) {
          if(Number(entranceFee) >= 10) {
            if(startDate.trim().length > 0) {
              //..
              setError(false);
              setLoading(true);
              let user = await appContext.getLocalUser();
              //console.log(user);
              await callGameServerApi(
                'create-league', 
                { 
                  playerId: user.userId,
                  userToken: user.userToken,
                  gameType: selectedGame,
                  noParticipants,
                  entranceFee,
                  startDate
                }).then(response => {
                if(response.status === 1) {
                  appContext.navTo({
                    item: 'browse_league',
                    subItem: response.uid,
                  });
                } else {
                  setLoading(false);
                  appContext.tellError(response.msg);
                  setError(response.msg);
                }
              })
              //..
            } else {
              appContext.tellError('Invalid league start date and time')
            }
          } else {
            appContext.tellError('Invalid entrance coins')
          }
        } else {
          appContext.tellError('Invalid number of participants')
        }
      } else {
        appContext.tellError('Invalid Game type')
      }

      
    }
  }

  


  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();

    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  useEffect(() => {
    setWinnerAward(calculateWinnerAward());
  }, [ entranceFee, noParticipants ])

  return (
    <>
      <TopBar title="Create League" />
      <div className="FullPane"  data-support-top-bar={true}>
        <div className='container'>
          <div className='row'>
            
            <div className='col-md-12' style={{ marginTop: "30px", marginBottom:"0px" }}>
              <div className='row'>

                <div className='col-12'>
                  <h6 className='text-goldish font-light' style={{ fontSize: "20px", marginBottom: "20px" }}>Select game type for this league</h6>
                </div>

                <div className='col-6'>
                  <button 
                    onClick={() => setSelectedGame(GAME_TYPES.BRAZILIAN_CHECKERS)} 
                    className={(selectedGame === GAME_TYPES.BRAZILIAN_CHECKERS) ? "btn btn-block bg-bluish" : "btn btn-block bg-faint-black"}
                  >
                    Brazilian <br/> Checkers
                  </button>
                </div>

                <div className='col-6'>
                  <button 
                    onClick={() => setSelectedGame(GAME_TYPES.SPANISH_CHECKERS)} 
                    className={(selectedGame === GAME_TYPES.SPANISH_CHECKERS) ? "btn btn-block bg-bluish" : "btn btn-block bg-faint-black"}
                  >
                    Spanish <br/> Checkers
                  </button>
                </div>

                <div className='col-6'>
                  <button 
                    onClick={() => setSelectedGame(GAME_TYPES.LASTCARD)} 
                    className={(selectedGame === GAME_TYPES.LASTCARD) ? "btn btn-block bg-bluish" : "btn btn-block bg-faint-black"}
                  >
                    Cards <br/> LastCard
                  </button>
                </div>

                <div className='col-6'>
                  <button 
                    onClick={() => setSelectedGame(GAME_TYPES.ARUBASTINI)} 
                    className={(selectedGame === GAME_TYPES.ARUBASTINI) ? "btn btn-block bg-bluish" : "btn btn-block bg-faint-black"}
                  >
                    Cards <br/> Arubastini
                  </button>
                </div>

              </div>
            </div>

            
            <div className='col-md-12' style={{ marginTop: "20px", marginBottom:"0px" }} >
              <div className='row'>
                
                <div className='col-6'>
                  <div className='form-group'>
                    <label>Number of <br/> Participants</label>
                    <select
                      value={noParticipants} 
                      onChange={(e) => { setNoParticipants(e.target.value) }} 
                      className='form-control' 
                      style={{
                        fontSize: "20px"
                      }}
                    >
                      <option value={2}>2</option>
                      <option value={4}>4</option>
                      <option value={8}>8</option>
                    </select>
                  </div>
                </div>

                <div className='col-6'>
                  <div className='form-group'>
                    <label>Entrance Coins <br/> (Kiingilio)</label>
                    <input
                      value={entranceFee} 
                      onChange={(e) => { setEntranceFee(e.target.value) }} 
                      className='form-control' 
                      style={{
                        fontSize: "20px",
                      }}
                      min={10}
                      type='number'
                    />
                    {
                      (Number(entranceFee) < 10) ?
                      <small className='form-text text-danger'>
                        Minimum is 10 coins
                      </small>
                      :""
                    }
                  </div>
                </div>

                <div className='col-12'>
                  <div className='form-group'>
                    <label>League Start Date and Time</label>
                    <input
                      value={startDate} 
                      onChange={(e) => { setStartDate(e.target.value) }} 
                      className='form-control' 
                      style={{
                        fontSize: "14px",
                      }}
                      type='datetime-local'
                    />
                    
                  </div>
                </div>

              </div>
            </div>

            <div className='col-md-12' style={{ marginTop: "20px", marginBottom:"0px" }}>
              <div className='row'>

                <div className='col-12'>
                  <label>Winner's Award</label>
                  <h6 className='text-goldish font-light' style={{ fontSize: "20px" }}>
                    <span style={{ fontSize: "36px" }}>{formatMoney(winnerAward)}</span> TZS
                  </h6>
                </div>

                

              </div>
            </div>

            <div className='col-md-12 text-end' style={{ marginTop: "20px", marginBottom:"0px" }}>
              {
                (error) ?
                <div className='text-start'>
                  <small className='text-danger'>{error}</small>
                </div>
                :""
              }
              <button
                className='btn btn-rounded bg-goldish'
                style={{
                  padding: "10px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
                onClick={() => {
                  appContext.activateDialog({
                    message: `Are you sure you want to create and join this league? You will be charged only the entrance fee of ${entranceFee} coins`,
                    onConfirm: createLeague,
                  })
                }}
              >
                Create League and Join
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );

  
}
